import { SupportedPlatforms } from '@smg-real-estate/domus';

export function getCurrentPlatform(): SupportedPlatforms {
  return import.meta.env.VUE_APP_PLATFORM === 'is24'
    ? SupportedPlatforms.is24
    : SupportedPlatforms.hg;
}

export function isHgPlatform(): boolean {
  return getCurrentPlatform() === SupportedPlatforms.hg;
}
